// CMS API client — public read endpoints + owner-gated authoring.
// Uses relative `/api` so dev proxy + production ingress both route correctly.

async function _fetch(path, options = {}) {
  const res = await fetch(`/api${path}`, {
    credentials: 'include',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
  if (!res.ok) {
    let detail = res.statusText;
    try { detail = (await res.json()).detail || detail; } catch { /* noop */ }
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  if (res.status === 204) return null;
  return res.json();
}

// ---------- Public reader ----------
export const cmsPublic = {
  listPages: () => _fetch('/cms/pages'),
  getPage: (slug) => _fetch(`/cms/pages/${slug}`),
};

// ---------- Owner authoring ----------
export const cmsOwner = {
  listPages: () => _fetch('/owner/cms/pages'),
  getPage: (slug) => _fetch(`/owner/cms/pages/${slug}`),
  updateBlock: (block_id, body) =>
    _fetch(`/owner/cms/blocks/${encodeURIComponent(block_id)}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    }),
  createBlock: (body) =>
    _fetch('/owner/cms/blocks', { method: 'POST', body: JSON.stringify(body) }),
  deleteBlock: (block_id) =>
    _fetch(`/owner/cms/blocks/${encodeURIComponent(block_id)}`, { method: 'DELETE' }),
  setPageStatus: (slug, status) =>
    _fetch(`/owner/cms/pages/${slug}`, {
      method: 'PATCH',
      body: JSON.stringify({ status }),
    }),
  seed: () => _fetch('/owner/cms/seed', { method: 'POST' }),
};
